import { render } from "./MaterialCard.vue?vue&type=template&id=1b143caa&scoped=true"
import script from "./MaterialCard.vue?vue&type=script&lang=js"
export * from "./MaterialCard.vue?vue&type=script&lang=js"

import "./MaterialCard.vue?vue&type=style&index=0&id=1b143caa&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b143caa"]])

export default __exports__